import { DataGrid, FabContainer, CreateFab } from '@arredo/reactjs-ui';
import useSettlements from "../../hooks/settlements/useSettlements";

import useAuthorize from "../../hooks/user/useAuthorize";
import {
  Box,
  Button,
  DialogActions,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  PaginationItem,
} from "@mui/material";
import { columns, title } from "../../models/SettlementEntity";
import SettlementFilters from "./filters";
import { Permissions } from "../../models/Roles";
import { Authenticate } from "../authentication";
import useNotify from "../../hooks/notify";
import { useState } from "react";
import Modal from "../../components/modal";
import { Receipt } from "@mui/icons-material";
import CreateSettlementModal from "./create";

const Settlements = () => {
  const isAuthorized = useAuthorize();
  const { Notify, variants } = useNotify();
  const {
    settlements,
    loading,
    filters,
    totalPage,
    create,
    clearFilters,
    setParameterSearch,
  } = useSettlements();
  const [selectedSettlement, setSelectedSettlement] = useState();
  const [showDetail, setShowDetail] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleFilterChange = (event) => {
    setParameterSearch({
      ...filters,
      [event.target.name]: event.target.value,
    });
  }
  const handleChangePage = (e, page) =>
    setParameterSearch({
      ...filters,
      pageNumber: Number(page),
    });

  const handleCreate = async (terminalId) => {
    setShowConfirm(false);
    try {
      const response = await Authenticate();
      if (!response.account)
        return Notify("Error al intentar realizar el logueo", variants.ERROR);
      const settlement = await create(terminalId, response.account.username);

      if (!settlement)
        Notify(
          `Se produjo un error al intentar crear el cierre`,
          variants.ERROR
        );
      else Notify("Cierre de Lote enviado a la terminal", variants.SUCCESS);
    } catch (err) {
      Notify(err.message, variants.ERROR);
    }
  };

  const handleSelect = (item) => {
    setSelectedSettlement(item);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setSelectedSettlement(null);
    setShowDetail(false);
  };

  return (
    <>
      {showDetail && selectedSettlement?.ticket && (
        <Modal
          open={showDetail}
          title="Detalle"
          dividers
          customButtons={() => (
            <DialogActions>
              <Button onClick={handleCloseDetail} color="primary">
                Cerrar
              </Button>
            </DialogActions>
          )}
          contentProps={{ alignItems: "center" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {selectedSettlement.ticket.split(/\r?\n/).map((l) => (
              <pre style={{ margin: 0 }} key={l}>
                {l}
              </pre>
            ))}
          </div>
        </Modal>
      )}
      {showConfirm && (
        <CreateSettlementModal
          onClose={() => setShowConfirm(false)}
          onCreate={handleCreate}
        />
      )}
      <Grid container spacing={1}>
        <Grid size="grow">
          <Box component={Paper} padding={2}>
            <Typography variant="h4">{title}</Typography>
          </Box>
        </Grid>
        <Grid size={12}>
          <SettlementFilters
            filters={filters}
            clearFilters={clearFilters}
            onFilterChange={handleFilterChange}
          />
        </Grid>
        <Grid size={12}>
          <DataGrid
            columns={columns}
            rows={settlements}
            loading={loading}
            paginationProps={{
              count: totalPage,
              page: filters?.pageNumber || 1,
              onChange: handleChangePage,
              renderItem: (item) => <PaginationItem {...item} />,
            }}
            actions={({ row }) => (
              <>
                {
                  row.ticket &&
                  (
                    <Tooltip title='Ver Ticket'>
                      <IconButton onClick={() => handleSelect(row)} size="large">
                        <Receipt fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )
                }
              </>
            )}
          />
        </Grid>
      </Grid>
      <FabContainer>
        {isAuthorized([Permissions.SettlementsCreate]) && (
          <CreateFab onClick={() => setShowConfirm(true)} />
        )}
      </FabContainer>
    </>
  );
};

export default Settlements;
